module.exports = __webpack_public_path__ + "img/orientation-vertical.1541bbb1.svg";